import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { resizeObserver1rxn81hcox9er as resizeObserver } from './helpers.commonHtml.js.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  ReactiveLoading_getInstance37x995i6zd62h as ReactiveLoading_getInstance,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Size2b01934yxlz5f as Size,
  Companion_getInstance1cv3d7873ycho as Companion_getInstance,
} from '../../models/Rect.mjs';
import { vevent2d70lzbz6q2i1 as vevent } from './helpers.commonHtml.mjs';
import {
  BasicListenable3uz4a8xs34a0h as BasicListenable,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  Companion_getInstanceok5aued8gko9 as Companion_getInstance_0,
  get_debugMode2ku08uo1anfv as get_debugMode,
  get_viewDebugTarget2umd1p7wjmzxt as get_viewDebugTarget,
} from '../../debugger.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { addClass1ihnmxbr5xjr2 as addClass } from '../../../../../../kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat/kotlinx/dom/Classes.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_ro__ndca26($this) {
  var tmp0 = $this.ydp_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ro', 1, tmp, ScrollingBehaviorImpl$_get_ro_$ref_fo7qe2(), null);
  return tmp0.f2();
}
function _get_clientSize__y98xgh($this) {
  var tmp0 = $this.zdp_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('clientSize', 1, tmp, ScrollingBehaviorImpl$_get_clientSize_$ref_9870qd(), null);
  return tmp0.f2();
}
function _get_scrollSize__2rvopp($this) {
  var tmp0 = $this.adq_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('scrollSize', 1, tmp, ScrollingBehaviorImpl$_get_scrollSize_$ref_utz749(), null);
  return tmp0.f2();
}
function ScrollingBehaviorImpl$_get_ro_$ref_fo7qe2() {
  return (p0) => _get_ro__ndca26(p0);
}
function ScrollingBehaviorImpl$_get_clientSize_$ref_9870qd() {
  return (p0) => _get_clientSize__y98xgh(p0);
}
function ScrollingBehaviorImpl$_get_scrollSize_$ref_utz749() {
  return (p0) => _get_scrollSize__2rvopp(p0);
}
function ScrollingBehaviorImpl$_get_viewport_$ref_fm96gf() {
  return (p0) => p0.zdg();
}
function ScrollingBehaviorImpl$_set_snapToElements_$lambda_larv83(it) {
  return startsWith(it, 'snapTo-');
}
function ScrollingBehaviorImpl$disableSnapTemporarily$lambda(it) {
  return startsWith(it, 'snapTo-');
}
var ScrollingBehaviorImplClass;
function ScrollingBehaviorImpl() {
  if (ScrollingBehaviorImplClass === VOID) {
    class $ {
      constructor(on, horizontal, vertical) {
        this.tdp_1 = on;
        this.udp_1 = horizontal;
        this.vdp_1 = vertical;
        this.wdp_1 = this.tdp_1.vb5_1;
        var tmp0 = this.wdp_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.lineHeight' call
        var value = '0px !important';
        tmp0.hb7_1.lineHeight = value;
        if (this.udp_1) {
          var tmp0_0 = this.wdp_1.jb4_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = 'scroll-horizontal';
          tmp0_0.v(element);
          // Inline function 'com.lightningkite.kiteui.views.overflowX' call
          this.wdp_1.db4_1.hb7_1.overflowX = 'auto';
        } else {
          // Inline function 'com.lightningkite.kiteui.views.overflowX' call
          this.wdp_1.db4_1.hb7_1.overflowX = 'none';
        }
        if (this.vdp_1) {
          var tmp0_1 = this.wdp_1.jb4_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = 'scroll-vertical';
          tmp0_1.v(element_0);
          // Inline function 'com.lightningkite.kiteui.views.overflowY' call
          this.wdp_1.db4_1.hb7_1.overflowY = 'auto';
        } else {
          // Inline function 'com.lightningkite.kiteui.views.overflowY' call
          this.wdp_1.db4_1.hb7_1.overflowY = 'none';
        }
        this.xdp_1 = true;
        var tmp = this;
        tmp.ydp_1 = lazy(() => resizeObserver(this.wdp_1));
        var tmp_0 = this;
        tmp_0.zdp_1 = lazy(() => reactive(this.tdp_1, ($this$reactive) => {
          $this$reactive.caj(_get_ro__ndca26(this));
          var tmp0_safe_receiver = this.wdp_1.xb3_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clientWidth;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
          var tmp;
          if (tmp2_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp = tmp2_elvis_lhs;
          }
          var tmp_0 = tmp;
          var tmp3_safe_receiver = this.wdp_1.xb3_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.clientHeight;
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
          var tmp_1;
          if (tmp5_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp_1 = tmp5_elvis_lhs;
          }
          return new (Size())(tmp_0, tmp_1);
        }));
        var tmp_1 = this;
        tmp_1.adq_1 = lazy(() => reactive(this.tdp_1, ($this$reactive) => {
          $this$reactive.caj(_get_ro__ndca26(this));
          var tmp0_safe_receiver = this.wdp_1.xb3_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scrollWidth;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
          var tmp;
          if (tmp2_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp = tmp2_elvis_lhs;
          }
          var tmp_0 = tmp;
          var tmp3_safe_receiver = this.wdp_1.xb3_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.scrollHeight;
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
          var tmp_1;
          if (tmp5_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp_1 = tmp5_elvis_lhs;
          }
          return new (Size())(tmp_0, tmp_1);
        }));
        this.bdq_1 = vevent(this.wdp_1, 'scroll');
        this.cdq_1 = BasicListenable().paq();
        this.ddq_1 = null;
        var tmp_2 = this;
        tmp_2.edq_1 = lazy(() => reactive(this.tdp_1, ($this$reactive) => {
          $this$reactive.caj(this.bdq_1);
          $this$reactive.caj(this.cdq_1);
          var tmp0_elvis_lhs = this.ddq_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0 = Companion_getInstance();
            var tmp1_safe_receiver = this.wdp_1.xb3_1;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.scrollLeft;
            var tmp_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
            var tmp3_safe_receiver = this.wdp_1.xb3_1;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.scrollTop;
            tmp = tmp_0.kd0(tmp_1, tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs, $this$reactive.daj(_get_clientSize__y98xgh(this)).vd0_1, $this$reactive.daj(_get_clientSize__y98xgh(this)).wd0_1);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        }));
        var tmp_3 = this;
        tmp_3.fdq_1 = lazy(() => reactive(this.tdp_1, ($this$reactive) => Companion_getInstance().kd0(0.0, 0.0, $this$reactive.daj(_get_scrollSize__2rvopp(this)).vd0_1, $this$reactive.daj(_get_scrollSize__2rvopp(this)).wd0_1)));
        this.gdq_1 = Signal().hak(false);
        this.hdq_1 = to(null, null);
        this.idq_1 = false;
        this.jdq_1 = 0;
      }
      qdj(value) {
        this.xdp_1 = value;
        if (value) {
          var tmp0 = this.wdp_1.jb4_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element = 'hideScrollbar';
          tmp0.w3(element);
        } else {
          var tmp0_0 = this.wdp_1.jb4_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = 'hideScrollbar';
          tmp0_0.v(element_0);
        }
      }
      zdg() {
        var tmp0 = this.edq_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('viewport', 1, tmp, ScrollingBehaviorImpl$_get_viewport_$ref_fm96gf(), null);
        return tmp0.f2();
      }
      tdj(value) {
        // Inline function 'com.lightningkite.kiteui.debugPrint' call
        var this_0 = this.tdp_1;
        if (get_debugMode() && equals(get_viewDebugTarget(), this_0)) {
          var tmp = Companion_getInstance_0().bbn('viewDebugTarget');
          var tmp$ret$0 = 'ScrollView.snapToElements set';
          tmp.cbn([tmp$ret$0]);
        }
        this.hdq_1 = value;
        var tmp_0 = this.wdp_1.jb4_1;
        removeAll(tmp_0, ScrollingBehaviorImpl$_set_snapToElements_$lambda_larv83);
        this.wdp_1.jb4_1.v('snapTo-' + toString(value.af_1) + '-' + toString(value.bf_1));
        this.wdp_1.cb9('scroll-snap-type', !(value.af_1 == null) && !(value.bf_1 == null) ? 'both mandatory' : !(value.af_1 == null) ? 'x mandatory' : !(value.bf_1 == null) ? 'y mandatory' : 'none');
      }
      udj(value) {
        // Inline function 'com.lightningkite.kiteui.debugPrint' call
        var this_0 = this.tdp_1;
        if (get_debugMode() && equals(get_viewDebugTarget(), this_0)) {
          var tmp = Companion_getInstance_0().bbn('viewDebugTarget');
          var tmp$ret$0 = 'ScrollView.scrollSnapStop set';
          tmp.cbn([tmp$ret$0]);
        }
        this.idq_1 = value;
        this.wdp_1.cb9('scroll-snap-stop', value ? 'always' : 'normal');
      }
      eb9(value) {
      }
      ndj(left, top, animated) {
        // Inline function 'com.lightningkite.kiteui.debugPrint' call
        var this_0 = this.tdp_1;
        if (get_debugMode() && equals(get_viewDebugTarget(), this_0)) {
          var tmp = Companion_getInstance_0().bbn('viewDebugTarget');
          var tmp$ret$0 = 'ScrollView.scrollTo(' + left + ', ' + top + ', ' + animated + ')';
          tmp.cbn([tmp$ret$0]);
        }
        this.kdq();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.wdp_1;
        var tmp0_safe_receiver = this_1.xb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_1 = tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE();
          var tmp_2;
          if (animated) {
            // Inline function 'org.w3c.dom.SMOOTH' call
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            tmp_2 = 'smooth';
          } else {
            // Inline function 'org.w3c.dom.INSTANT' call
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            tmp_2 = 'instant';
          }
          // Inline function 'org.w3c.dom.ScrollToOptions' call
          var behavior = tmp_2;
          var o = {};
          o['left'] = left;
          o['top'] = top;
          o['behavior'] = behavior;
          tmp_1.scrollTo(o);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.wb3_1.v((it) => {
            var tmp = it instanceof HTMLElement ? it : THROW_CCE();
            var tmp0 = left;
            var tmp2 = top;
            var tmp_0;
            if (animated) {
              // Inline function 'org.w3c.dom.SMOOTH' call
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              tmp_0 = 'smooth';
            } else {
              // Inline function 'org.w3c.dom.INSTANT' call
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              tmp_0 = 'instant';
            }
            // Inline function 'org.w3c.dom.ScrollToOptions' call
            var behavior = tmp_0;
            var o = {};
            o['left'] = tmp0;
            o['top'] = tmp2;
            o['behavior'] = behavior;
            tmp.scrollTo(o);
            return Unit_instance;
          });
        }
      }
      kdq() {
        var tmp = this.wdp_1.jb4_1;
        removeAll(tmp, ScrollingBehaviorImpl$disableSnapTemporarily$lambda);
        this.wdp_1.cb9('scroll-snap-type', 'unset');
      }
      pdj(x, y) {
        this.jdq_1 = this.jdq_1 + 1 | 0;
        var myInstance = this.jdq_1;
        // Inline function 'com.lightningkite.kiteui.debugPrint' call
        var this_0 = this.tdp_1;
        if (get_debugMode() && equals(get_viewDebugTarget(), this_0)) {
          var tmp = Companion_getInstance_0().bbn('viewDebugTarget');
          var tmp$ret$0 = 'ScrollView.scrollToKeepAnimations(' + x + ', ' + y + ')';
          tmp.cbn([tmp$ret$0]);
        }
        this.kdq();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.wdp_1;
        var tmp0_safe_receiver = this_1.xb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var it = tmp0_safe_receiver;
          if (!(it instanceof HTMLElement))
            THROW_CCE();
          addClass(it, ['suppress-overflow-anchors']);
          var tmp_1 = this;
          var tmp_2 = Companion_getInstance();
          var tmp0_safe_receiver_0 = this.wdp_1.xb3_1;
          var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.clientWidth;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
          var tmp_3 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
          var tmp3_safe_receiver = this.wdp_1.xb3_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.clientHeight;
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
          tmp_1.ddq_1 = tmp_2.kd0(x, y, tmp_3, tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs);
          it.scrollLeft = x;
          it.scrollTop = y;
          var amount = 32;
          var inductionVariable = 1;
          var last = amount - 1 | 0;
          if (inductionVariable <= last)
            do {
              var count = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp_4 = window;
              tmp_4.setTimeout(() => {
                var tmp;
                if (!(myInstance === this.jdq_1)) {
                  return Unit_instance;
                }
                it.scrollLeft = x;
                it.scrollTop = y;
                return Unit_instance;
              }, count);
            }
             while (!(count === last));
          // Inline function 'com.lightningkite.kiteui.afterTimeout' call
          var milliseconds = fromInt(amount);
          var tmp_5 = window;
          var handle = tmp_5.setTimeout(() => {
            $l$block: {
              if (!(myInstance === this.jdq_1)) {
                break $l$block;
              }
              if (!(this.hdq_1.af_1 == null) || !(this.hdq_1.bf_1 == null)) {
                this.tdj(this.hdq_1);
                it.scrollLeft = x;
                it.scrollTop = y;
              }
              this.ddq_1 = null;
              this.cdq_1.qaq();
            }
            return Unit_instance;
          }, convertToInt(milliseconds));
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.wb3_1.v((it) => {
            var it_0 = it;
            if (!(it_0 instanceof HTMLElement))
              THROW_CCE();
            addClass(it_0, ['suppress-overflow-anchors']);
            var tmp = this;
            var tmp_0 = Companion_getInstance();
            var tmp0_safe_receiver = this.wdp_1.xb3_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clientWidth;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
            var tmp_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
            var tmp3_safe_receiver = this.wdp_1.xb3_1;
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.clientHeight;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
            tmp.ddq_1 = tmp_0.kd0(x, y, tmp_1, tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs);
            it_0.scrollLeft = x;
            it_0.scrollTop = y;
            var amount = 32;
            var inductionVariable = 1;
            var last = amount - 1 | 0;
            if (inductionVariable <= last)
              do {
                var count = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp_2 = window;
                tmp_2.setTimeout(() => {
                  var tmp;
                  if (!(myInstance === this.jdq_1)) {
                    return Unit_instance;
                  }
                  it_0.scrollLeft = x;
                  it_0.scrollTop = y;
                  return Unit_instance;
                }, count);
              }
               while (!(count === last));
            // Inline function 'com.lightningkite.kiteui.afterTimeout' call
            var milliseconds = fromInt(amount);
            var tmp_3 = window;
            var handle = tmp_3.setTimeout(() => {
              $l$block_0: {
                if (!(myInstance === this.jdq_1)) {
                  break $l$block_0;
                }
                if (!(this.hdq_1.af_1 == null) || !(this.hdq_1.bf_1 == null)) {
                  this.tdj(this.hdq_1);
                  it_0.scrollLeft = x;
                  it_0.scrollTop = y;
                }
                this.ddq_1 = null;
                this.cdq_1.qaq();
              }
              return Unit_instance;
            }, convertToInt(milliseconds));
            return Unit_instance;
          });
        }
      }
    }
    initMetadataForClass($, 'ScrollingBehaviorImpl');
    ScrollingBehaviorImplClass = $;
  }
  return ScrollingBehaviorImplClass;
}
//region block: exports
export {
  ScrollingBehaviorImpl as ScrollingBehaviorImpl35p8dxbs74spr,
};
//endregion

//# sourceMappingURL=ScrollView.commonHtml.js.mjs.map
